export default {
    state: {
        currentSong: null
    },
    mutations: {
        playSong(state, song) {
            state.currentSong = song;
        },
        stopSong(state) {
            state.currentSong = null;
        }
    },
    actions: {
        playSong(context, song) {
            context.commit('playSong', song);
        },
        stopSong(context) {
            context.commit('stopSong');
        }
    },
    getters: {
    }
};
